import type { Category } from "../types";

const CATEGORY_LABEL_TO_KEY: Record<string, Category["key"]> = {
  Courses: "course",
  "Executive Education": "executiveEducation",
  Certificates: "certificate",
  "Master's Degrees": "masters",
  "Bachelor's Degrees": "bachelors",
};

export function resolveCategoryKey(c: Category): Category["key"] | undefined {
  if (c.key) return c.key;
  return CATEGORY_LABEL_TO_KEY[c.categoryLabel];
}

/** Stable sort: lower rank first; unknown keys keep input order via original index. */
export function sortTrendingCategoriesByKeyOrder(
  categories: Category[],
  categoryKeyOrder: Category["key"][],
): Category[] {
  if (!categoryKeyOrder.length) return categories;
  const withIndex = categories.map((c, i) => ({ c, i }));
  const rank = (c: Category) => {
    const k = resolveCategoryKey(c);
    if (!k) return categoryKeyOrder.length + 100;
    const idx = categoryKeyOrder.indexOf(k);
    return idx === -1 ? categoryKeyOrder.length + 100 : idx;
  };
  withIndex.sort((a, b) => {
    const dr = rank(a.c) - rank(b.c);
    if (dr !== 0) return dr;
    return a.i - b.i;
  });
  return withIndex.map((x) => x.c);
}
